import LockIcon from 'assets/icons/lock-icon.svg?component'
import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import tw from 'twin.macro'

import ContainerWithSteps from '../../components/UI/Container/ContainerWithSteps'
import Link from '../../components/UI/Link'
import Typography from '../../components/UI/Typography'
import Heading from '../../components/UI/Typography/Heading'
import { useAppSelector } from '../../hooks'
import { getNotificationsSelector } from '../../redux/store/slices/wsSlice'
import { ApplicationEvents } from '../../share/enums/events'
import { getWsStepStatus } from '../../utils'
import Emitter from '../../utils/emitter'
const OwnDebt = () => {
  const { CHECK_TAX_DEBT } = useAppSelector(getNotificationsSelector)
  const { t, i18n } = useTranslation()
  useEffect(() => {
    const checkWsStep = async () => {
      const fetchDdocsStepStatus = getWsStepStatus(CHECK_TAX_DEBT)
      if (fetchDdocsStepStatus === 'DONE') {
        Emitter.emit(ApplicationEvents.NAVIGATE_TO_NEXT_PAGE)
      }
    }
    // twStyle='text-3xl text-center font-bold'
    checkWsStep()
  }, [CHECK_TAX_DEBT])

  return (
    <ContainerWithSteps>
      <div className={'flex flex-col items-center'}>
        <LockIcon className={'my-8'} />
        <Typography twStyle={tw`text-3xl text-center font-bold mb-4`}>{t('you-have-tax-debt')}</Typography>
        <Typography twStyle={tw`text-base	text-center font-normal text-[#B7BBBD]`}>
          {t('pay-off-your-tax-debt')}
        </Typography>
        <Typography variant='subbody' as='span' twStyle={tw`text-base	text-center font-normal text-[#B7BBBD]`}>
          <Trans
            components={{
              a: <Link href={'https://kgd.gov.kz/' + i18n.language} target='_blank' rel='noreferrer' />
            }}
          >
            {t('more-info-about-tax-debt')}
          </Trans>
        </Typography>
      </div>
    </ContainerWithSteps>
  )
}

export default OwnDebt
